/* eslint-disable no-console */

import { register } from 'register-service-worker'



if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered...')
    },
    cached () {
      console.log('Content has been cached for offline use. cach')
    },
    updatefound () {
      console.log('New content is downloading.')

    },
    updated (registration) {
      console.log('New content is available; please refresh! ')
      var UpdatedEvent = new CustomEvent('swUpdated', { detail: registration });
      document.dispatchEvent(UpdatedEvent);
    },
    offline () {
      var OL = new CustomEvent('offline', {detail:'offline'})
      document.dispatchEvent(OL)
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    },
    coolio (c) {
      console.log('This is coolio', c)
    }
  })
}
